import React from "react";
import { string, bool, oneOfType, node } from "prop-types";
import { classes } from "../utils/classes";
import forwardRefPropType from "../utils/forward-ref";

const Select = ({ className, error, forwardRef, ...props }) => (
	<select
		ref={forwardRef}
		className={classes("field__select", error && "field--error", className)}
		{...props}
	/>
);

Select.propTypes = {
	className: string,
	error: oneOfType([bool, string, node]),
	forwardRef: forwardRefPropType,
};

const MSelect = React.memo(Select);

MSelect.Placeholder = function SelectPlaceholder(props) {
	return <option value="" {...props} />;
};

const getValue = item => item?.value;
const getTitle = item => item?.title;

// eslint-disable-next-line react/display-name
const renderItem = (prepareValue = getValue, prepareText = getTitle) => item => {
	const value = prepareValue(item);
	const text = prepareText(item);
	return (
		<option key={value} value={value}>
			{text}
		</option>
	);
};

MSelect.renderOptions = (items, prepareValue, prepareText) =>
	items.map(renderItem(prepareValue, prepareText));

export default MSelect;
